(function () {
  const KEY = 'vx-demo-cart';

  function catalog() {
    const el = document.getElementById('vx-catalog');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return [];
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[char]));
  }

  function readCart() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function writeCart(items) {
    sessionStorage.setItem(KEY, JSON.stringify(items));
    paintBubble(items.reduce((sum, item) => sum + (item.qty || 1), 0));
  }

  function paintBubble(count) {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    let bubble = icon.querySelector('.cart-count-bubble');
    if (count < 1) {
      if (bubble && !bubble.dataset.shopify) bubble.remove();
      return;
    }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true">0</span>';
      icon.appendChild(bubble);
    }
    const num = bubble.querySelector('[aria-hidden="true"]');
    if (num) num.textContent = String(count);
    bubble.hidden = false;
  }

  function addItem(payload) {
    const items = readCart();
    const found = items.find((item) => item.handle === payload.handle);
    if (found) found.qty += 1;
    else items.push({ ...payload, qty: 1 });
    writeCart(items);
    return items;
  }

  function bindAddButtons(root) {
    (root || document).querySelectorAll('[data-vx-add]').forEach((button) => {
      button.addEventListener('click', () => {
        addItem({
          handle: button.dataset.handle,
          title: button.dataset.title,
          vendor: button.dataset.vendor,
          price: button.dataset.price,
          image: button.dataset.image,
          href: button.dataset.href,
        });
        button.textContent = 'Agregado';
        const status = (root || document).querySelector('[data-vx-add-status]');
        if (status) {
          status.hidden = false;
          status.innerHTML = 'Listo en el carrito. <a href="/cart">Ver carrito</a>';
        }
      });
    });
  }

  function pdpMarkup(item) {
    const related = catalog()
      .filter((other) => other.vendor_handle === item.vendor_handle && other.handle !== item.handle)
      .map(
        (other) => `
        <a class="vx-product" href="${escapeHtml(other.href)}">
          <div class="vx-product__thumb">
            <img src="${escapeHtml(other.image)}" alt="${escapeHtml(other.title)}" width="400" height="400">
          </div>
          <div class="vx-product__body">
            <div class="vx-product__name">${escapeHtml(other.title)}</div>
            <div class="vx-product__price">${escapeHtml(other.price)}</div>
          </div>
        </a>`
      )
      .join('');

    return `
      <div class="vx vx-pdp" data-vx-pdp>
        <div class="vx-page vx-pdp__wrap">
          <nav class="vx-pdp__crumb">
            <a href="/">Inicio</a>
            <span>/</span>
            <a href="${escapeHtml(item.vendor_href)}">${escapeHtml(item.vendor)}</a>
            <span>/</span>
            <span>${escapeHtml(item.title)}</span>
          </nav>
          <div class="vx-pdp__grid">
            <div class="vx-pdp__media">
              <img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="900" height="900">
            </div>
            <div class="vx-pdp__info">
              <a class="vx-eyebrow" href="${escapeHtml(item.vendor_href)}">${escapeHtml(item.vendor)}</a>
              <h1 class="vx-pdp__title">${escapeHtml(item.title)}</h1>
              <div class="vx-pdp__price">${escapeHtml(item.price)}</div>
              ${item.blurb ? `<p class="vx-pdp__blurb">${escapeHtml(item.blurb)}</p>` : ''}
              <div class="vx-pdp__actions">
                <button type="button" class="vx-pdp__add button" data-vx-add
                  data-handle="${escapeHtml(item.handle)}"
                  data-title="${escapeHtml(item.title)}"
                  data-vendor="${escapeHtml(item.vendor)}"
                  data-price="${escapeHtml(item.price)}"
                  data-image="${escapeHtml(item.image)}"
                  data-href="${escapeHtml(item.href)}">Agregar</button>
                <a class="vx-chip" href="${escapeHtml(item.vendor_href)}">Ver vendedor</a>
              </div>
              <p class="vx-pdp__status" data-vx-add-status hidden></p>
            </div>
          </div>
          ${
            related
              ? `<div class="vx-pdp__related"><h2>También de ${escapeHtml(item.vendor)}</h2><div class="vx-products">${related}</div></div>`
              : ''
          }
        </div>
      </div>`;
  }

  function renderPdpFromPath() {
    const match = window.location.pathname.match(/\/products\/([^/]+)/i);
    if (!match) return false;
    const handle = decodeURIComponent(match[1]).toLowerCase();
    const item = catalog().find((entry) => String(entry.handle || '').toLowerCase() === handle);
    if (!item) return false;
    const mount = document.querySelector('[data-vx-pdp-mount]');
    if (!mount) return false;
    mount.className = '';
    mount.innerHTML = pdpMarkup(item);
    document.title = `${item.title} | Vivox`;
    bindAddButtons(mount);
    return true;
  }

  function renderCartPage() {
    const mount = document.querySelector('[data-vx-demo-cart]');
    if (!mount) return;
    const items = readCart();
    if (!items.length) {
      mount.hidden = true;
      return;
    }
    mount.hidden = false;
    const rows = items
      .map(
        (item) => `
        <a class="vx-demo-cart__row" href="${item.href}">
          <img src="${item.image}" alt="${item.title}" width="72" height="72">
          <div>
            <div class="vx-event__vendor">${item.vendor}</div>
            <div class="vx-product__name">${item.title}</div>
            <div class="vx-product__price">${item.price} · ${item.qty}</div>
          </div>
        </a>`
      )
      .join('');
    mount.innerHTML = `
      <h2>Tu selección</h2>
      <div class="vx-demo-cart__list">${rows}</div>
      <p class="vx-note">El checkout de Shopify se activa cuando el catálogo esté publicado. Por ahora podés revisar la ficha y el vendedor.</p>
    `;
  }

  paintBubble(readCart().reduce((sum, item) => sum + (item.qty || 1), 0));
  if (!renderPdpFromPath()) bindAddButtons();
  renderCartPage();
})();
